import storage from '../../../storage';
import logger from "../../../logger.js";
import ExceptionUserExist from "@/exceptions/ExceptionUserExist.js";
import ExceptionBadResponse from "@/exceptions/ExceptionBadResponse.js";
// import Axios
import Axios from 'axios';
// instantiate axios
const axios = Axios.create();


// setup query endpoint
const secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
const endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY;

function createUser(user) {
    return axios.post(endpoint + "/api/services-new/auth/v1/register", user) // eslint-disable-next-line
        .then(response => null)
        .catch(error => {
            if(error.response) {
                    let url = error.response.config.url?error.response.config.url:'';
                    let status = error.response.status;
                    let message = error.response.data.message ? error.response.data.message : error.response.data.error.message;
                    logger.error(`component: RegisterHotel, url: ${url}, status: ${status}, message: ${message}`, error.stack)
                        .then(() => null)
                } else {
                    logger.error(error.message, error.stack)
                        .then(() => null);
                }
            if (error.response.status == 422) throw new ExceptionUserExist();
            throw new ExceptionBadResponse();
            
        });
}

async function getUserMe() {
    let token = await storage.getToken();
    return axios.get(endpoint + "/api/services-new/profiles/users/me", {
        headers: {
            Authorization: token
        }
    }) // eslint-disable-next-line
        .then(response => {
            return response.data
        })
        .catch(error => {
            if(error.response) {
                    let url = error.response.config.url?error.response.config.url:'';
                    let status = error.response.status;
                    let message = error.response.data.message ? error.response.data.message : error.response.data.error.message;
                    logger.error(`component: RegisterHotel, url: ${url}, status: ${status}, message: ${message}`, error.stack)
                        .then(() => null)
                } else {
                    logger.error(error.message, error.stack)
                        .then(() => null);
                }
            throw new ExceptionBadResponse();
            
        });
}

async function assignRole(user_id, role_id) {
    let token = await storage.getToken();
    return axios.post(endpoint  + "/api/services-new/roles/users/" + user_id + "/roles/" + role_id, {}, {
            headers: {
                Authorization: token
            }
        }) // eslint-disable-next-line
        .then(response => null)
        .catch(error => {
            if(error.response) {
                    let url = error.response.config.url?error.response.config.url:'';
                    let status = error.response.status;
                    let message = error.response.data.message ? error.response.data.message : error.response.data.error.message;
                    logger.error(`component: RegisterHotel, url: ${url}, status: ${status}, message: ${message}`, error.stack)
                        .then(() => null)
                } else {
                    logger.error(error.message, error.stack)
                        .then(() => null);
                }
            throw new ExceptionBadResponse();
        });
}

export default {
  createUser,
  getUserMe,
  assignRole
};
